import {
  Directive,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID
  } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
export class OffClickDirective implements OnInit, OnDestroy {
public offClickHandler: any;
/**
 * @param {?} platformId
 */
constructor(
private platformId: string) { }
/**
 * @return {?}
 */
public ngOnInit(): any {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => { document.addEventListener('click', this.offClickHandler); }, 0);
    }
  }
/**
 * @return {?}
 */
public ngOnDestroy(): any {
    if (isPlatformBrowser(this.platformId)) {
      document.removeEventListener('click', this.offClickHandler);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[off-click]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'offClickHandler': [{ type: Input, args: ['off-click', ] },],
};
}

function OffClickDirective_tsickle_Closure_declarations() {
/** @type {?} */
OffClickDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OffClickDirective.ctorParameters;
/** @type {?} */
OffClickDirective.propDecorators;
/** @type {?} */
OffClickDirective.prototype.offClickHandler;
/** @type {?} */
OffClickDirective.prototype.platformId;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
